import React from "react"
import PropTypes from "prop-types"

class PaymentOptionRadioInput extends React.Component {
  static defaultProps = {
    selected: false
  }

  static propTypes = {
    children: PropTypes.any.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    value: PropTypes.string.isRequired
  }

  render() {
    const { children, id, name, onChange, selected, value } = this.props

    return (
      <div className="mb-1">
        <input
          className="radio"
          defaultChecked={selected ? "checked" : null}
          id={id}
          name={name}
          onChange={onChange}
          type="radio"
          value={value}
          css={{
            opacity: 0,
            position: "absolute",
            "&:checked + label": {
              backgroundColor: "var(--success-notice--background-color)"
            },
            "& + label .icon-wrapper": { display: "none" },
            "&:checked + label .icon-wrapper": {
              display: "block"
            }
          }}
        />
        <label
          htmlFor={id}
          className="fs-3 p-r d-f ai-c"
          css={{
            padding: 12,
            backgroundColor: "var(--color-tint9)",
            borderRadius: 4
          }}
        >
          {children}
          <span
            className="fs-4 c-emerald icon-wrapper"
            css={{
              position: "absolute",
              right: 16,
              top: 14
            }}
          >
            <svg
              id="Layer_1"
              className="check-mark-icon"
              css={{
                fill: "currentColor",
                height: "1em",
                width: "1em"
              }}
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
            >
              <title>check</title>
              <polygon points="5.091 11.236 1.273 7.418 0 8.691 5.091 13.782 16 2.873 14.727 1.6 5.091 11.236" />
            </svg>
          </span>
        </label>
      </div>
    )
  }
}

export default PaymentOptionRadioInput
